/*=========================================================================================
  File Name: modulePurchaseReturnGetters.js
  Description: Purchase Return Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
